import { render, staticRenderFns } from "./CountPerHoursChart.vue?vue&type=template&id=0b2773a5&"
import script from "./CountPerHoursChart.vue?vue&type=script&lang=js&"
export * from "./CountPerHoursChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports